export default "__VITE_ASSET__Vs5T0j1T__"